import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, Signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { RouterFacade } from '@core/shared/data-access';
import { HeaderElementDirective } from '@core/shared/util';
import { RootModuleNavComponent } from '@core/ui';
import { UsersFacade } from '@mp/kernel/users/data-access';
import { IdentityUserListItem } from '@mp/kernel/users/domain';
import { UsersListViewComponent } from '@mp/kernel/users/ui';

@Component({
  selector: 'mpk-users-list',
  templateUrl: './users-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UsersListViewComponent, HeaderElementDirective, RootModuleNavComponent],
})
export class UsersListComponent implements OnInit {
  protected readonly users: Signal<IdentityUserListItem[]> = this.usersFacade.users;

  protected readonly usersLoaded: Signal<boolean> = this.usersFacade.usersLoaded;

  protected readonly listView = viewChild(UsersListViewComponent);

  constructor(
    private readonly usersFacade: UsersFacade,
    private readonly routerFacade: RouterFacade,
    private readonly destroyRef: DestroyRef,
  ) {
    this.loadUsers();
  }

  ngOnInit(): void {
    this.routerFacade.activeRoute$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((route) => {
      const userId = route.snapshot.paramMap.get('userId');
      if (userId) {
        this.listView()?.tryScrollIntoView(userId);
      }
    });
  }

  loadUsers(searchTerm?: string): void {
    this.usersFacade.fetchUsers(searchTerm);
  }
}
